<template>
    <ui-container class="py-8" v-if="this.form">
        <ui-header :title="editMode ? `Editing Toolbox Talk - ${item.title}` : 'Create new Toolbox Talk'"
                   :subtitle="editMode ? 'ID #'+this.item.id : null">
            <template #actions>
                <ui-button-new icon="fas fa-arrow-left" @click="finished()" v-if="editMode">Done</ui-button-new>
            </template>
        </ui-header>
        <label class="my-0 py-2 mt-4">Toolbox Talk</label>
        <div class="grid gap-6 grid-cols-12 py-0">
            <ui-input label="Talk Reference" name="reference" v-model="form.reference"
                      placeholder="Toolbox Talk reference"
                      ref="reference"
                      class="xl:col-span-6" :error="form.errors.get('reference')"
                      @input="save"></ui-input>

            <ui-input label="Talk Title" name="title" v-model="form.title"
                      placeholder="Title of toolbox talk..."
                      ref="title"
                      class="xl:col-span-12" :error="form.errors.get('title')" @input="save"></ui-input>

            <ui-textarea autoresize label="Talk" name="talk" v-model="form.talk"
                         placeholder="Talk data in here...."
                         ref="talk"
                         class="xl:col-span-12" :error="form.errors.get('talk')"
                         @input="save"></ui-textarea>

        </div>
        <ui-data-grid-item wide class="mt-6 flex" v-if="!editMode">
            <div class="flex flex-col md:flex-row justify-end flex-wrap">
                <ui-button-new v-if="editMode" @click="edit(false)" class="ml-3">Cancel</ui-button-new>
                <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy" class="ml-3">Create
                </ui-button-new>
            </div>
        </ui-data-grid-item>

    </ui-container>

</template>

<script>
import {ToolboxTalkLibraryItem} from '@models'
import UiInput from "../../ui/UiInput.vue";
import draggable from 'vuedraggable'
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import moment from "moment/moment";
import {uuid} from "../../../utils";

export default {
    components: {
        UiDropdown,
        UiDropdownItem,
        UiDataGridItem,
        UiDataGrid,
        AutoresizableTextarea,
        UiButtonNew,
        UiDatePicker,
        UiContainer,
        draggable,
        UiInput
    },
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data() {
        const initialData = this.item ? this.item.getFormAttributes() : {
            reference: '',
            title: '',
            talk: '',
        };
        return {
            currentAttendees: this.attendees ? this.attendees.slice(0) : [],
            updated: false,
            toolboxTalkLibraryItem: null,
            form: null,
            errors: {
                date: null
            },
            saving: false,
            saveAgain: false,
        }
    },
    methods: {
        save() {
            if (this.editMode) {
                if (this.saving) {
                    this.saveAgain = true;
                }
                this.saving = true
                this.form.submit()
            }
        },
        update() {
            this.updated = true;
            this.save();
        },
        finished() {
            let sorter = (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            };
            this.edit(false, sorter)
        }
    },
    computed: {
        editMode() {
            return !!this.item
        },
    },
    async mounted() {
        if (this.item) {
            this.toolboxTalkLibraryItem = this.item
            this.currentAttendees = this.item.attendees
        } else {
            this.toolboxTalkLibraryItem = {attendees: []}
        }
        this.form = new Form(this.editMode ? this.toolboxTalkLibraryItem.getFormAttributes() : this.toolboxTalkLibraryItem, async (form) => {
            this.saving = true;
            do {
                this.saveAgain = false
                let data = form.export();
                let sorter = (items) => {
                    items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
                };
                if (this.editMode) {
                    await this.toolboxTalkLibraryItem.update(data).then(() =>
                        Object.assign(this.item, this.toolboxTalkLibraryItem)
                    )
                    this.edit(true, sorter)
                } else {
                    const toolbox_talk = await ToolboxTalkLibraryItem.create(uuid(), data)

                    this.addItem(toolbox_talk, 0, sorter);
                    form.reset()
                }
            } while (this.saveAgain)
            this.saving = false;
        })
    }
}
</script>
